import * as React from 'react'

const MHDescriptionText = (props) => {
  return (
  <p className="hero--subheading pb-2">
    { props.description }
  </p>
  )
}

export default MHDescriptionText
